<script setup>
import {ref, watch} from "vue";

const {selectedReloadInterval} = defineProps(['reloadIntervalValues', 'selectedReloadInterval'])
const emit = defineEmits(['update:selectedReloadInterval'])

const selectedValue = ref('')

watch(() => selectedReloadInterval, (newValue) => {
    selectedValue.value = newValue
}, {immediate: true})

</script>

<template>
    <select name="rt-auto-reload-select" v-model="selectedValue" @change="emit('update:selectedReloadInterval', $event.target.value)" >
        <option v-for="val in reloadIntervalValues" :value="val.label">{{ val.label }}</option>
    </select>
</template>

<style scoped>

</style>
